// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DeleteIcon_wrapper__m8eYm","label":"DeleteIcon_label__ezgNY"};